import { FormControl, InputLabel, MenuItem, OutlinedInput, Select, SelectChangeEvent } from "@mui/material";
import * as React from 'react';

export interface MultipleStrikeSelectorProps {
    strikes: number[];
    value: number;
    onValueChange: (newSelectedValue: number) => void;
}

export function MultipleStrikeSelector({
    strikes,
    value,
    onValueChange,
}: MultipleStrikeSelectorProps) {
    const onChange = (eventArg: SelectChangeEvent<string>): void => {
        onValueChange(Number(eventArg.target.value));
        setTimeout(() => {
            (document.activeElement as HTMLElement | null)?.blur();
        }, 0);
    }
    
    return (
        <FormControl
            variant="standard"
            size="small"
            sx={{ width: 120 }}
        >
            <InputLabel id="strike-label">
                <b>Strikes</b> {getSelectControlLabelExtension(strikes)}
            </InputLabel>
            <Select
                labelId="strike-label"
                value={value?.toString() ?? ' '}
                onChange={onChange}
                {...(strikes.length === 0
                    ? { disabled: true }
                    : {})}
            >
                {strikes.map((strike) => (
                    <MenuItem
                        key={strike}
                        value={strike.toString()}
                    >
                        {strike}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

function getSelectControlLabelExtension(strikes: number[]): string | null {
    return strikes.length > 0
        ? `(${strikes.length} available)`
        : null;
}